module.exports = __webpack_public_path__ + "img/honor_9.f625fd6d.png";